module.exports = __webpack_public_path__ + "static/img/5.9cfdbfc4.jpg";